import type { StoreActionApi } from 'react-sweet-state';
import { ff } from '@atlassian/jira-feature-flagging';
import type { IssueAdjustmentsState } from '../../types';
import type { ErrorState } from './types';

export const setError =
	(errorProperties: ErrorState) =>
	({ setState }: StoreActionApi<IssueAdjustmentsState>) => {
		setState({
			error: {
				errorCode: errorProperties.errorCode,
				fieldName: ff('forge-ui-modifications-validation-errors-returned-to-app_hdzmw')
					? errorProperties.fieldName
					: undefined,
			},
		});
	};

export const resetError =
	() =>
	({ setState }: StoreActionApi<IssueAdjustmentsState>) => {
		setState({
			error: null,
		});
	};
